class FormSettings {
  checkboxIsSwitch: boolean;
  remainSignedIn: boolean;
  addressForm: {
    showPhone: boolean,
  }
  googlePay: {
    basketColor: 'default' | 'black' | 'white',
    checkoutColor: 'default' | 'black' | 'white',
  };
}
const formSettings = new FormSettings();

formSettings.checkboxIsSwitch = false;
formSettings.remainSignedIn = false;
formSettings.addressForm = {
  showPhone: true,
};
formSettings.googlePay = {
  basketColor: 'black',
  checkoutColor: 'black',
}

export {formSettings, FormSettings};
